/**
 * Omni Pane — types, from the generated API client.
 *
 * The wire shapes are generated from the FastAPI routes
 * (backend/omni/api/http/pane_routes.py); this file only names them for
 * the pane module. `TileKind` is the server's component vocabulary
 * (`backend/omni/modules/pane/components.py`); the registry is a full
 * `Record<TileKind, …>`, so a kind added on the server and not drawn here
 * fails `pnpm typecheck`.
 *
 * Spec: Docs/architecture/24-omni-pane.md.
 */
import type { CreateTileBody, TileResponse, UpdateTileBody } from "@/api";

export type { CreateTileBody, UpdateTileBody };

/**
 * One widget on the user's canvas. Geometry (x, y, w, h) is in 12-column
 * grid cells. `kind` is a plain string on the way out: rows written before
 * the vocabulary can carry a kind this build does not draw (FallbackTile).
 */
export type PaneTile = TileResponse;

/** A kind the server accepts and the registry draws. */
export type TileKind = CreateTileBody["kind"];

/** Number of grid columns. Mirrors the backend's PANE_COLS = 12. */
export const PANE_COLS = 12;
